import React, { useEffect } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import LegendContent from "../utils/legend-content.jsx";
import {getDateRangeSortValue} from "../utils/vehicle-passages-search-utils.jsx";
import { tableSortHeader } from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";

const UserAnalysisContent = ({ payload, tableColumns }) => {
    const data = payload?.userAnalysis;
    const {order, handleSort, sortedData, getIcon} = tableSortHeader(data, {date_range: (row) => getDateRangeSortValue(row)});

    const columns = [
        {id: "user_name", className: "w-[18%]", renderCell: element => element.user_name},
        {id: "date_search", className: "w-[15%]", renderCell: element => element.date_search ?? "Todo período"},
        {id: "search", className: "w-[10%]", renderCell: element => <span style={{fontWeight: 700}}>{element.search}</span>},
        {id: "similar_plate", className: "w-[7%]", renderCell: element => element.similar_plate === ('true' || 'True' || 'TRUE') ? "Sim" : "Não"},
        {id: "correspondent_plate", className: "w-[7%]", renderCell: element => element.correspondent_plate === ('true' || 'True' || 'TRUE') ? "Sim" : "Não"},
        {id: "date_range", className: "w-[35%]", renderCell: element => element.date_range},
        {id: "auto_search", className: "w-[8%]", renderCell: element => element.auto_search === ('true' || 'True' || 'TRUE') ? "Sim" : "Não"},
    ];

    const visibleColumns = columns.filter(
        column => tableColumns?.[column.id]?.visible !== false,
    );

    useEffect(() => {
        if (!data || !visibleColumns.length) return;
        ReportUtils.createExportableTable(null, null, 'Passagens (por usuário)', "passage-user-data");
    }, [data, tableColumns]);

    if (!data) return null;

    return (
        <>
            {visibleColumns.length ? (
                <table id="passage-user-data" className="table report-table" sheet-name="Passagens (por usuário)">
                    <thead className="thead-background table-row-group!">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map(column => (
                                <th key={column.id} onClick={() => handleSort(column.id)} className={`${column.className} cursor-pointer`}>
                                    {tableColumns?.[column.id]?.label ?? column.id} {getIcon(order, column.id)}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                        {sortedData.map((element, index) => (
                            <tr key={index} className="table-break-word">
                                {visibleColumns.map(column => (
                                    <td key={column.id} className={column.className}>
                                        {column.renderCell(element)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <LegendContent/>
        </>
    );
};

export default UserAnalysisContent;